import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { FormikProps } from 'formik';
import { useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { PmiButton } from 'shell/components/shared/button';
import { FiltersFormForeignState } from 'system/geographic/pages/state/list/types';
import PmiTextField from 'shell/components/shared/text-field';

interface FiltersForeignStateProps {
  filterForeignStateForm: FormikProps<FiltersFormForeignState>;
}

const FiltersForeignState = ({
  filterForeignStateForm,
}: FiltersForeignStateProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-state-content"
        id="panel-state-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filterForeignStateForm.handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Sigla stato"
                label="Sigla stato"
                id="acronym"
                name="acronym"
                fullWidth
                onBlur={filterForeignStateForm.handleBlur}
                type="text"
                variant="outlined"
                inputProps={{
                  maxLength: '3',
                }}
                value={filterForeignStateForm.values.acronym}
                onChange={(event) =>
                  filterForeignStateForm.setFieldValue(
                    'acronym',
                    event.target.validity.valid
                      ? event.target.value
                      : filterForeignStateForm.values.acronym
                  )
                }
                error={
                  filterForeignStateForm.touched.acronym &&
                  Boolean(filterForeignStateForm.errors.acronym)
                }
                helperText={filterForeignStateForm.errors.acronym}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Codice stato"
                label="Codice stato"
                id="code"
                name="code"
                fullWidth
                onBlur={filterForeignStateForm.handleBlur}
                type="text"
                inputProps={{
                  maxLength: '3',
                }}
                variant="outlined"
                value={filterForeignStateForm.values.code}
                onChange={(event) => {
                  filterForeignStateForm.setFieldValue('code', event.target.value);
                }}
                error={
                  filterForeignStateForm.touched.code && Boolean(filterForeignStateForm.errors.code)
                }
                helperText={filterForeignStateForm.errors.code}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Nome stato"
                label="Nome stato"
                id="name"
                name="name"
                fullWidth
                onBlur={filterForeignStateForm.handleBlur}
                type="text"
                inputProps={{
                  maxLength: '40',
                }}
                variant="outlined"
                value={filterForeignStateForm.values.name}
                onChange={(event) => {
                  filterForeignStateForm.setFieldValue('name', event.target.value);
                }}
                error={
                  filterForeignStateForm.touched.name && Boolean(filterForeignStateForm.errors.name)
                }
                helperText={filterForeignStateForm.errors.name}
              />
            </Grid>
            <Grid item xs>
              <PmiButton
                variant="contained"
                color="secondary"
                type="submit"
                disabled={!filterForeignStateForm.isValid}
              >
                Cerca
              </PmiButton>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FiltersForeignState.displayName = 'Filters Foreign State component';

export default FiltersForeignState;
